module.exports = __webpack_public_path__ + "img/add_enclosure.74525a63.svg";